export function getApiErrorReason(error: unknown, fallback = 'Request failed'): string {
  if (!error || typeof error !== 'object') return fallback;
  const value = error as { data?: unknown; reason?: unknown; message?: unknown; status?: unknown; originalStatus?: unknown };
  const data = value.data;
  if (data && typeof data === 'object' && 'reason' in data && typeof data.reason === 'string' && data.reason.trim()) return data.reason;
  if (typeof value.reason === 'string' && value.reason.trim()) return value.reason;
  if (error instanceof Error) return error.message;
  const status = value.originalStatus ?? value.status;
  if (status === 403) return 'You do not have permission to perform this action.';
  if (status === 404) return 'The requested resource is unavailable.';
  if (status === 401) return 'Your session has expired. Please sign in again.';
  return fallback;
}

export async function parseApiResponse(response: Response): Promise<unknown> {
  const text = await response.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    // Never display an HTML error page or arbitrary server output as a reason.
    return { type: 'error', reason: getApiErrorReason({ status: response.status }, `Request failed (HTTP ${response.status}).`) };
  }
}
